/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED API METHODS - DO NOT EDIT
 * Generated from: MerchantMembersContract
 */

import { apiClient } from '../../utils/api-client';
import { toIsoString } from '@zlinkx/shared-v2';
import type {
  CreateCardBackgroundBodyType,
  CreateCardBackgroundParamsType,
  CreateCardBackgroundResponseType,
  CreateCardBalancesBodyType,
  CreateCardBalancesParamsType,
  CreateCardBalancesResponseType,
  CreateMemberEnrollmentBodyType,
  CreateMemberEnrollmentParamsType,
  CreateMemberEnrollmentResponseType,
  CreateMerchantGroupBodyType,
  CreateMerchantGroupMemberAssignmentBodyType,
  CreateMerchantGroupMemberAssignmentParamsType,
  CreateMerchantGroupMemberAssignmentResponseType,
  CreateMerchantGroupParamsType,
  CreateMerchantGroupResponseType,
  CreatePersonalMemberCardBodyType,
  CreatePersonalMemberCardParamsType,
  CreatePersonalMemberCardResponseType,
  GetCardBalancesParamsType,
  GetCardBalancesResponseType,
  GetMemberParamsType,
  GetMemberResponseType,
  GetMerchantGroupParamsType,
  GetMerchantGroupResponseType,
  GetPersonalMemberCardParamsType,
  GetPersonalMemberCardResponseType,
  ListMemberGroupCardsParamsType,
  ListMemberGroupCardsResponseType,
  ListMembersParamsType,
  ListMembersQueryType,
  ListMembersResponseType,
  ListMerchantGroupsParamsType,
  ListMerchantGroupsResponseType,
  MessageResponse,
  RemoveCardBackgroundBodyType,
  RemoveCardBackgroundParamsType,
  RemoveCardBackgroundResponseType,
  RemoveMerchantGroupMemberParamsType,
  UpdateMemberCreditsBodyType,
  UpdateMemberCreditsParamsType,
  UpdateMerchantGroupBodyType,
  UpdateMerchantGroupParamsType,
  UpdateMerchantGroupResponseType,
  UpdatePersonalMemberCardBodyType,
  UpdatePersonalMemberCardParamsType,
  UpdatePersonalMemberCardResponseType,
} from '@zlinkx/shared-v2';

type SerializableQueryValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;

function serializeQueryValue(value: unknown): string | number | boolean | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (value instanceof Date) {
    return toIsoString(value);
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }

  return String(value);
}

function serializeQueryParams(params?: Record<string, unknown>): Record<string, SerializableQueryValue> | undefined {
  if (!params) {
    return undefined;
  }

  const serialized: Record<string, SerializableQueryValue> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const arrayValues = value
        .map(item => serializeQueryValue(item))
        .filter((item): item is string | number | boolean => item !== undefined);

      if (arrayValues.length > 0) {
        serialized[key] = arrayValues;
      }
      return;
    }

    const scalarValue = serializeQueryValue(value);
    if (scalarValue !== undefined) {
      serialized[key] = scalarValue;
    }
  });

  return Object.keys(serialized).length > 0 ? serialized : undefined;
}

export const merchantmembersApi = {
  listMembers: async (
    merchantId: ListMembersParamsType['merchantId'],
    params?: ListMembersQueryType
  ): Promise<ListMembersResponseType> => {
    return apiClient.get<ListMembersResponseType['data']>(`/merchants/${merchantId}/members`, { params: serializeQueryParams(params) }) as Promise<ListMembersResponseType>;
  },

  getMember: async (
    merchantId: GetMemberParamsType['merchantId'],
    userId: GetMemberParamsType['userId']
  ): Promise<GetMemberResponseType> => {
    return apiClient.get<GetMemberResponseType['data']>(`/merchants/${merchantId}/members/${userId}`) as Promise<GetMemberResponseType>;
  },

  updateMemberCredits: async (
    merchantId: UpdateMemberCreditsParamsType['merchantId'],
    userId: UpdateMemberCreditsParamsType['userId'],
    data: UpdateMemberCreditsBodyType
  ): Promise<MessageResponse> => {
    return apiClient.patch(`/merchants/${merchantId}/members/${userId}/credits`, data);
  },

  getPersonalMemberCard: async (
    merchantId: GetPersonalMemberCardParamsType['merchantId'],
    userId: GetPersonalMemberCardParamsType['userId']
  ): Promise<GetPersonalMemberCardResponseType> => {
    return apiClient.get<GetPersonalMemberCardResponseType['data']>(`/merchants/${merchantId}/members/${userId}/personal-card`) as Promise<GetPersonalMemberCardResponseType>;
  },

  createPersonalMemberCard: async (
    merchantId: CreatePersonalMemberCardParamsType['merchantId'],
    userId: CreatePersonalMemberCardParamsType['userId'],
    data: CreatePersonalMemberCardBodyType
  ): Promise<CreatePersonalMemberCardResponseType> => {
    return apiClient.post<CreatePersonalMemberCardResponseType['data']>(`/merchants/${merchantId}/members/${userId}/personal-card`, data) as Promise<CreatePersonalMemberCardResponseType>;
  },

  updatePersonalMemberCard: async (
    merchantId: UpdatePersonalMemberCardParamsType['merchantId'],
    userId: UpdatePersonalMemberCardParamsType['userId'],
    data: UpdatePersonalMemberCardBodyType
  ): Promise<UpdatePersonalMemberCardResponseType> => {
    return apiClient.post<UpdatePersonalMemberCardResponseType['data']>(`/merchants/${merchantId}/members/${userId}/personal-card/edit`, data) as Promise<UpdatePersonalMemberCardResponseType>;
  },

  getCardBalances: async (
    merchantId: GetCardBalancesParamsType['merchantId'],
    cardId: GetCardBalancesParamsType['cardId']
  ): Promise<GetCardBalancesResponseType> => {
    return apiClient.get<GetCardBalancesResponseType['data']>(`/merchants/${merchantId}/member-cards/${cardId}/balances`) as Promise<GetCardBalancesResponseType>;
  },

  createCardBalances: async (
    merchantId: CreateCardBalancesParamsType['merchantId'],
    cardId: CreateCardBalancesParamsType['cardId'],
    data: CreateCardBalancesBodyType
  ): Promise<CreateCardBalancesResponseType> => {
    return apiClient.post<CreateCardBalancesResponseType['data']>(`/merchants/${merchantId}/member-cards/${cardId}/balances`, data) as Promise<CreateCardBalancesResponseType>;
  },

  createCardBackground: async (
    merchantId: CreateCardBackgroundParamsType['merchantId'],
    cardId: CreateCardBackgroundParamsType['cardId'],
    data: CreateCardBackgroundBodyType
  ): Promise<CreateCardBackgroundResponseType> => {
    return apiClient.post<CreateCardBackgroundResponseType['data']>(`/merchants/${merchantId}/member-cards/${cardId}/background`, data) as Promise<CreateCardBackgroundResponseType>;
  },

  removeCardBackground: async (
    merchantId: RemoveCardBackgroundParamsType['merchantId'],
    cardId: RemoveCardBackgroundParamsType['cardId'],
    data: RemoveCardBackgroundBodyType
  ): Promise<RemoveCardBackgroundResponseType> => {
    return apiClient.post<RemoveCardBackgroundResponseType['data']>(`/merchants/${merchantId}/member-cards/${cardId}/background/remove`, data) as Promise<RemoveCardBackgroundResponseType>;
  },

  listMerchantGroups: async (
    merchantId: ListMerchantGroupsParamsType['merchantId']
  ): Promise<ListMerchantGroupsResponseType> => {
    return apiClient.get<ListMerchantGroupsResponseType['data']>(`/merchants/${merchantId}/member-groups`) as Promise<ListMerchantGroupsResponseType>;
  },

  getMerchantGroup: async (
    merchantId: GetMerchantGroupParamsType['merchantId'],
    cardId: GetMerchantGroupParamsType['cardId']
  ): Promise<GetMerchantGroupResponseType> => {
    return apiClient.get<GetMerchantGroupResponseType['data']>(`/merchants/${merchantId}/member-groups/${cardId}`) as Promise<GetMerchantGroupResponseType>;
  },

  createMerchantGroup: async (
    merchantId: CreateMerchantGroupParamsType['merchantId'],
    data: CreateMerchantGroupBodyType
  ): Promise<CreateMerchantGroupResponseType> => {
    return apiClient.post<CreateMerchantGroupResponseType['data']>(`/merchants/${merchantId}/member-groups`, data) as Promise<CreateMerchantGroupResponseType>;
  },

  updateMerchantGroup: async (
    merchantId: UpdateMerchantGroupParamsType['merchantId'],
    cardId: UpdateMerchantGroupParamsType['cardId'],
    data: UpdateMerchantGroupBodyType
  ): Promise<UpdateMerchantGroupResponseType> => {
    return apiClient.post<UpdateMerchantGroupResponseType['data']>(`/merchants/${merchantId}/member-groups/${cardId}/edit`, data) as Promise<UpdateMerchantGroupResponseType>;
  },

  createMerchantGroupMemberAssignment: async (
    merchantId: CreateMerchantGroupMemberAssignmentParamsType['merchantId'],
    cardId: CreateMerchantGroupMemberAssignmentParamsType['cardId'],
    data: CreateMerchantGroupMemberAssignmentBodyType
  ): Promise<CreateMerchantGroupMemberAssignmentResponseType> => {
    return apiClient.post<CreateMerchantGroupMemberAssignmentResponseType['data']>(`/merchants/${merchantId}/member-groups/${cardId}/members`, data) as Promise<CreateMerchantGroupMemberAssignmentResponseType>;
  },

  removeMerchantGroupMember: async (
    merchantId: RemoveMerchantGroupMemberParamsType['merchantId'],
    cardId: RemoveMerchantGroupMemberParamsType['cardId'],
    userId: RemoveMerchantGroupMemberParamsType['userId']
  ): Promise<MessageResponse> => {
    return apiClient.delete(`/merchants/${merchantId}/member-groups/${cardId}/members/${userId}/remove`);
  },

  listMemberGroupCards: async (
    merchantId: ListMemberGroupCardsParamsType['merchantId'],
    userId: ListMemberGroupCardsParamsType['userId']
  ): Promise<ListMemberGroupCardsResponseType> => {
    return apiClient.get<ListMemberGroupCardsResponseType['data']>(`/merchants/${merchantId}/members/${userId}/group-cards`) as Promise<ListMemberGroupCardsResponseType>;
  },

  createMemberEnrollment: async (
    merchantId: CreateMemberEnrollmentParamsType['merchantId'],
    data: CreateMemberEnrollmentBodyType
  ): Promise<CreateMemberEnrollmentResponseType> => {
    return apiClient.post<CreateMemberEnrollmentResponseType['data']>(`/merchants/${merchantId}/members/enrollment`, data) as Promise<CreateMemberEnrollmentResponseType>;
  },
};